import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useSharesTransferModal } from '../context/SharesTransferModalContext';

const SharesTransferModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSharesTransferModal();

  const ADD_PARTNER_OPTION = 'add-partner';

  const isSamePartner =
    data.selectedPartnerBuyerOption?.value ===
    data.selectedPartnerSellerOption?.value;

  const hasInvalidPartnerBuyer =
    data.selectedPartnerBuyerOption?.value === ADD_PARTNER_OPTION ||
    !data.selectedPartnerBuyerOption;

  const buttonSaveMovementDisabled =
    !data.validatedRanges.length || isSamePartner || hasInvalidPartnerBuyer;

  const buttonNextDisabled = !data.date;

  const buttonSaveOperationDisabled =
    !data.scriptureView &&
    (data.validatedRanges.length > 0 || !data.historyMovements.length);

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <>
      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          {!data.scriptureView && (
            <button
              type="button"
              id="save-movement-button"
              className="btn btn-lg btn-primary"
              onClick={actions.handleSaveMovement}
              disabled={buttonSaveMovementDisabled}
            >
              {t('SaveMovement')}
            </button>
          )}
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={actions.handleSaveSharesTransfer}
            disabled={buttonNextDisabled || buttonSaveOperationDisabled}
          >
            {buttonText}
          </button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default SharesTransferModalFooter;
